module.exports = __webpack_public_path__ + "static/img/hopbomb_logo.d46964e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hopbomb_logo.png
// module id = 298
// module chunks = 1